import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import {
  ContactMethod,
  allRecipientTypes,
  allRecipientTypesOptions,
} from 'components/Notifications/recipientTypes';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';

type FormSelectMethodProps = {
  fieldName: string;
  rules?: { [key: string]: { value: any; message: string } };
  recipientTypeOptions?: ContactMethod[];
};

const FormSelectMethod: React.FC<FormSelectMethodProps> = ({
  fieldName,
  rules,
  recipientTypeOptions,
}) => {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  register(fieldName, rules);
  const fieldValue: ContactMethod[] = watch(fieldName) || [];

  const handleButtonClick = (value: ContactMethod) => {
    if (fieldValue?.includes(value)) {
      setValue(
        fieldName,
        fieldValue.filter((v) => v !== value)
      );
    } else {
      setValue(
        fieldName,
        [...fieldValue, value].sort(
          (a, b) =>
            allRecipientTypesOptions.findIndex((option) => option === a) -
            allRecipientTypesOptions.findIndex((option) => option === b)
        )
      );
    }
  };

  return (
    <>
      <div className="d-flex mt-3">
        {allRecipientTypes
          .filter((option) =>
            recipientTypeOptions
              ? recipientTypeOptions.includes(option.label)
              : true
          )
          .map((option) => {
            const selected = fieldValue?.includes(option.label);
            return (
              <StylishNewButton
                key={option.label}
                onClick={() => handleButtonClick(option.label)}
                className={classNames(
                  selected ? 'button--secondary-fill' : 'button--secondary',
                  'me-2'
                )}
              >
                <SharedIcon
                  iconName={selected ? 'check' : option.icon}
                  classes={'me-2'}
                  color={selected ? 'success' : 'light'}
                />
                {option.label}
              </StylishNewButton>
            );
          })}
      </div>
      {errors[fieldName] ? (
        <div className="form-text form-error">
          {errors[fieldName].message as string}
        </div>
      ) : (
        <div className="form-text-none"></div>
      )}
    </>
  );
};
export default FormSelectMethod;
